import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AppStateService} from "../../providers/app-state.service";
import {CommonUtils} from "../../utils/common";
import {KlinikaxpPaymentRequiredReservation} from "../../models/klinikaxp-payment-required-reservation.model";
import {ModalController} from "@ionic/angular";
import {AbstractControl, FormControl, Validators} from "@angular/forms";
import {timeValidator} from "../../utils/form-validators";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-data-picker-for-additional-kxp-res-time',
  templateUrl: './data-picker-for-additional-kxp-res-time.component.html',
  styleUrls: ['./data-picker-for-additional-kxp-res-time.component.scss'],
})
export class DataPickerForAdditionalKxpResTimeComponent implements OnInit, OnDestroy {

  isBusy: boolean;
  @Input()
  klinikaxpPaymentRequiredReservation: KlinikaxpPaymentRequiredReservation;

  @Input()
  canSendSms: boolean;

  @Input()
  vetcodeId: number;

  maxDate: string;
  minDate: any;
  timeToPrepaidControl: FormControl;
  protected minDateinDateType: Date;
  protected maxDateInDate: Date;
  protected fullPrepaidDate: Date;
  private calendarChanged: boolean;
  datePreviousSelected: string;
  dateToPrepaid: string;
  dateIsValid: boolean;
  protected initialFullPrepaidDate: Date;
  protected smsBalanceIsCorrect: boolean;
  private smsServerBalanceCheckSub: Subscription;
  sendSMS: boolean;




  constructor(private appStateService: AppStateService,
              private commonUtils: CommonUtils, private modalController: ModalController, private vetClinicService: VetClinicService) {
  }

  ngOnInit() {
    this.minDateinDateType = new Date(new Date(this.klinikaxpPaymentRequiredReservation.finalPaymentDate).getTime());
    this.minDate = this.commonUtils.dateToYearMonthDayString(this.minDateinDateType);
    this.maxDateInDate = new Date(new Date(this.klinikaxpPaymentRequiredReservation.startDate).getTime());
    this.maxDate = this.maxDateInDate.toISOString();
    this.dateToPrepaid = this.minDate;
    this.datePreviousSelected = this.minDate;
    this.fullPrepaidDate = new Date(this.klinikaxpPaymentRequiredReservation.finalPaymentDate);
    this.initialFullPrepaidDate = this.fullPrepaidDate;
    this.timeToPrepaidControl = new FormControl(this.getDefaultTimeToPrepaid(this.fullPrepaidDate), [Validators.required, timeValidator]);

    if (this.canSendSms) {
      this.smsServerBalanceCheckSub = this.vetClinicService.checkSmsServerBalance(this.vetcodeId).subscribe(r => {
        this.smsBalanceIsCorrect = r;
      }, error => {
        this.smsBalanceIsCorrect = false;
        console.log(error)
        this.commonUtils.presentAlertToast('Brak wystarczających środków do wysłania SMS');
      });
    }
  }


  ngOnDestroy(): void {
    if (this.smsServerBalanceCheckSub) {
      this.smsServerBalanceCheckSub.unsubscribe();
    }
  }

  onCancelEdit() {
    this.modalController.dismiss();
  }

  changeDate() {
    this.klinikaxpPaymentRequiredReservation.finalPaymentDate = this.commonUtils.date2StrLong(this.fullPrepaidDate);
    this.klinikaxpPaymentRequiredReservation.sendSMS = this.sendSMS;
    this.modalController.dismiss(this.klinikaxpPaymentRequiredReservation);
  }

  changeCalendarValue($event) {
    const dateSplited = $event;
    if (dateSplited === this.datePreviousSelected.split("T")[0]) {
      this.calendarChanged = true;
    } else {
      this.calendarChanged = true;
      this.dateToPrepaid = dateSplited;
      const dateSplitedInDate = new Date(dateSplited);
      if ((dateSplitedInDate.getDate() === this.minDateinDateType.getDate())
        && (dateSplitedInDate.getMonth() === this.minDateinDateType.getMonth())) {
        this.timeToPrepaidControl.setValue(this.getDefaultTimeToPrepaid(this.minDateinDateType));
      } else if ((dateSplitedInDate.getDate() === this.maxDateInDate.getDate())
        && (dateSplitedInDate.getMonth() === this.maxDateInDate.getMonth())) {
        this.timeToPrepaidControl.setValue(this.getDefaultTimeToPrepaid(new Date(this.maxDateInDate.getTime() - 3600000)));
      } else {
        this.timeToPrepaidControl.setValue('23:59');
      }
      const prepaidDateTimestamp = Date.parse(this.dateToPrepaid.concat('T', this.timeToPrepaidControl.value, ':00'));
      this.fullPrepaidDate = new Date(prepaidDateTimestamp);
    }
    this.datePreviousSelected = $event.detail.value;

  }

  checkIfTimeIsValid($event) {
    if ($event.detail.value) {
      if (this.checkTimeFormat($event.detail.value)) {
        if (this.timeToPrepaidControl.value) {
          const prepaidDateTimestamp = Date.parse(this.dateToPrepaid.concat('T', this.timeToPrepaidControl.value, ':00'));
          const fullDate = new Date(prepaidDateTimestamp);
          if (fullDate < this.minDateinDateType) {
            this.dateIsValid = false;
            this.timeToPrepaidControl.setErrors({tooEarly: true});
          } else if (fullDate > new Date(new Date(this.klinikaxpPaymentRequiredReservation.startDate))) {
            this.dateIsValid = false;
            this.timeToPrepaidControl.setErrors({tooLate: true});
          }
          else {
            this.dateIsValid = true;
            this.fullPrepaidDate = new Date(prepaidDateTimestamp);
          }
        }
      } else {
        this.dateIsValid = false;
      }
    }
  }

  checkTimeFormat(txt) {
    const regex = new RegExp('^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$');
    return regex.test(txt);
  }

  getDefaultTimeToPrepaid(date: Date) {
    const hour: number = date.getHours();
    const minute: number = date.getMinutes();
    let hourString: string = hour.toString();
    let minuteString: string = minute.toString();

    if (hour < 10) {
      hourString = '0'.concat(hourString);
    }
    if (minute < 10) {
      minuteString = '0'.concat(minuteString);
    }
    return hourString.concat(':', minuteString);
  }

  getNewDateColor() {
    return this.noChangeDetected() ? 'primary' : 'secondary';
  }

  noChangeDetected() {
    return this.fullPrepaidDate.getTime() === this.initialFullPrepaidDate.getTime();
  }
}
